import { getApi } from "./apiService";
import { axiosInstance } from "./axiosInstance";

export const getRevenueSummary = async (queryParams = {}) => {
    const queryString = new URLSearchParams(queryParams).toString();
    return await getApi(`mp/analytics/revenue/summary?${queryString}`);
};
export const getRevenueTrend = async (queryParams = {}) => {
    const queryString = new URLSearchParams(queryParams).toString();
    return await getApi(`mp/analytics/revenue/trend?${queryString}`);
};
export const getTopProducts = async (queryParams = {}) => {
    const queryString = new URLSearchParams(queryParams).toString();
    return await getApi(`mp/analytics/top/products?${queryString}`);
};
export const getTopClasses = async (queryParams = {}) => {
    const queryString = new URLSearchParams(queryParams).toString();
    return await getApi(`mp/analytics/top/classes?${queryString}`);
};
export const getCustomerDemographics = async () => {
    return await getApi(`mp/analytics/customers/demographics`);
};
export const getUnderPerformingProduct = async (queryParams = {}) => {
    const queryString = new URLSearchParams(queryParams).toString();
    return await getApi(`mp/analytics/underperforming/products?${queryString}`);
};
export const ExportAnalytics = async (queryParams = {}) => {
    const queryString = new URLSearchParams(queryParams).toString();
    const url = `/mp/analytics/export?${queryString}`;

    const response = await axiosInstance.get(url, {
        responseType: "blob", // 👈 critical
        headers: {
            // Authorization: `Bearer ${token}`,
        },
    });

    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    const downloadUrl = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = "revenue-summary.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
};
